var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"input":_vm.changeTxt,"focus":function($event){_vm.lock=true},"blur":function($event){_vm.lock=false}}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd36f52","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contenteditable/Contenteditable.vue
// module id = 1902
// module chunks = 137